import { useLingui } from '@lingui/react/macro';
import type { FC } from 'react';
import type { WealthMarketplaceMerchantStatus } from '@/backend';
import { Badge } from '@/shared/Badge';

export const MerchantStatusBadge: FC<{
  status: WealthMarketplaceMerchantStatus;
  label?: boolean;
  size?: 4 | 5 | 6 | 8;
}> = ({ status, size = 6, label = false }) => {
  const { t } = useLingui();
  const labelPrefix = label ? <>{t`Merchant Application`}: </> : '';

  switch (status) {
    case 'APPROVED':
      return (
        <Badge size={size} variant="positive" icon>
          {labelPrefix}
          {t`Verified`}
        </Badge>
      );
    case 'PENDING':
      return (
        <Badge size={size} variant="notice" icon>
          {labelPrefix}
          {t`Under Review`}
        </Badge>
      );
    case 'REJECTED':
      return (
        <Badge size={size} variant="negative" icon>
          {labelPrefix}
          {t`Rejected`}
        </Badge>
      );
    case 'SUSPENDED':
      return (
        <Badge size={size} variant="negative" icon>
          {labelPrefix}
          {t`Suspended`}
        </Badge>
      );
    default:
      return (
        <Badge size={size} variant="gray">
          {labelPrefix}
          {status}
        </Badge>
      );
  }
};
